import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router, RouterModule } from '@angular/router';
import { GlobalContants, Resource } from 'src/app/constants/global.contants';
import { MaterialModule } from 'src/app/material.module';
import { ApiTitleComponent } from '../../common/api-title/api-title.component';
import { environment } from 'src/environments/environment';
import { SharedService } from 'src/app/services/shared.service';
import { UserService } from 'src/app/services/user.service';
import { ApiUIResponseComponent } from '../api-ui-response/api-ui-response.component';
import { HTTPMethod } from 'src/app/constants/enum';
import { apiEndPoints } from 'src/app/constants/api-endpointsconstant';

export interface statusCode {
  key: string;
  value: string;
  required: boolean
}

const Headers: statusCode[] = [
  {
    key : "Content-Type",
    value: 'application/json',
    required: false
  },  
  {
    key : "API-KEY",
    value: '{{API-KEY}}',
    required: true
  },
  {
    key : "USER-TOKEN",
    value: '{{USER-TOKEN}}',
    required: true
  },
];
const QueryData :any =[
  {
    param : "lat",
    value: '{{lat}}',
    required: true
  },
  {
    param : "lon",
    value: '{{lon}}',
    required: true
  }
]

@Component({
  selector: 'app-nearby-group',
  standalone: true,
  imports: [CommonModule, MaterialModule, RouterModule, ApiTitleComponent,ApiUIResponseComponent],
  templateUrl: './nearby-group.component.html'
})
export class NearbyGroupComponent {
  HTTPMethod = HTTPMethod;
  displayedColumns: string[] = ['key', 'value', 'required'];
  QueryColumns: string[] = ['param', 'value', 'required'];
  dataSource = Headers;
  QueryDataSource = QueryData;
api_ui: boolean = false;

  GlobalContants = GlobalContants
  constructor(private sharedService: SharedService, 
        private userService: UserService, 
        private router: Router){}

  ngOnInit() {
    let userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    this.userService.getAllUserResource(userInfo.user_id)
      .subscribe({
        next: (res: any) => {
          const matched = res.data.find((r: any) => r.resource_name === Resource.NearbyData);
            if (!matched?.methods?.includes(HTTPMethod.GET)) {
              this.router.navigate(['/'])
            }
        },
        error: (err) => {
        }
      })
   }

  ngAfterViewInit(){
   
  }

  api_demo= `${environment.apiBaseUrl}${apiEndPoints.nearbyData}`;

  api_response = `{
  "status": 0,
  "message": "string",
  "data": {
    "roads": [
      {
        "road_name": "string",
        "category": "string",
        "distance": 0,
        "road_width": 0
      }
    ],
    "amenities": [
      {
        "property_name": "string",
        "category": "string",
        "distance": 0
      }
    ]
  }
}`;


}
